import { ADMIN_SESSION_KEY, readStoredAdminSession } from '../admin/adminUtils';

export function checkoutAuthHeaders() {
  const t = String(readStoredAdminSession() || sessionStorage.getItem(ADMIN_SESSION_KEY) || '').trim();
  return {
    'Content-Type': 'application/json',
    'X-Admin-Session': t,
    Authorization: `Bearer ${t}`,
  };
}
